import { ListEmptyState, PageLayout } from '@spotify/confidence-core-react';
import { useCurrentIdentity } from '@spotify/plugin-confidence-iam-react';

import { useCollection } from '../../hooks';
import { makeFavoritesCollectionName } from '../../utils';
import { CollectionEntriesList } from '../CollectionPage/CollectionEntriesList';

// TODO: Move FavoritesPage to a dedicated plugin (e.g. confidence-favorites)
// so it can own its own route refs and plugin registration.
export const FavoritesPage = () => {
  const { currentIdentity } = useCurrentIdentity();
  const name = currentIdentity?.name
    ? makeFavoritesCollectionName(currentIdentity.name)
    : undefined;

  const { collection, isLoading } = useCollection({
    name: name!,
    skip: !name,
  });

  return (
    <PageLayout enableMargin title="Favorites" isLoading={isLoading}>
      {!collection && !isLoading ? (
        <ListEmptyState
          title="No favorites yet"
          description="Star a resource to add it to your favorites."
        />
      ) : (
        name && <CollectionEntriesList collectionName={name} isFavorites />
      )}
    </PageLayout>
  );
};
